//生产
const pro = "https://meetingapi.simon-cloud.com.cn/";
//测试
const dev = "http://192.168.1.30:21023/";
//本地
const local = 'http://localhost:21023/';

 const URL = process.env.NODE_ENV === 'production' ? pro : process.env.NODE_ENV === 'development' ? dev : local;
//const URL = local;
export default URL;